import LocalStorageCollection from "../prototypes/LocalStorageCollection";
import PaymentModeCollection from "./PaymentModeCollection";
import PaymentGroupModel from "./PaymentGroupModel";
import PaymentModeModel from "./PaymentModeModel";
//
// Collection PaymentGroup
//

class PaymentGroupCollection extends LocalStorageCollection<PaymentGroupModel> {
  name = "PaymentGroupCollection";
  route = "apiPaymentGroupCollection";
  idAttribute = "id_payment_group";
  model = PaymentGroupModel;

  initialize(
    models?: Record<string, any>[] | PaymentGroupModel[],
    options?: any
  ): void {
    // ObjectCollection constructor heritage
    super.initialize.apply(this, [models, options]);
  }

  setup() {
    this.each((paymentGroup) => {
      paymentGroup.setup();
    });
  }

  getPaymentModes(): PaymentModeCollection {
    const paymentModes = new PaymentModeCollection();
    this.each((paymentGroup, i) => {
      const paymentGroupModes = paymentGroup.getPaymentModes();
      paymentGroupModes.each((paymentMode) => {
        paymentModes.push(paymentMode);
      });
    });
    return paymentModes;
  }

  getPaymentMode(id_payment_mode: any): PaymentModeModel | undefined {
    const group = this.find((paymentGroup) => {
      let paymentModeModel = paymentGroup.getPaymentMode(id_payment_mode);
      return !!paymentModeModel;
    });

    if (group) {
      return group.getPaymentMode(id_payment_mode);
    }
  }
}

PaymentGroupCollection.prototype.name = "PaymentGroupCollection";
PaymentGroupCollection.prototype.route = "apiPaymentGroupCollection";
PaymentGroupCollection.prototype.model = PaymentGroupModel;
export default PaymentGroupCollection;
